/**
 * Densidad de las tablas — preferencia del usuario.
 *
 * `comfortable` (por defecto histórico) deja las filas a ~44 px; `compact`
 * las deja en ~32 px, que en un portátil de 14" son 4 filas más por pantalla.
 * `auto` (valor de fábrica) usa la compacta solo cuando la ventana es baja o
 * estrecha, que es justo el caso en el que el alto se paga caro.
 *
 * Se resuelve en CSS con `html[data-density]` (ver `styles/lists.css` §13):
 * así el cambio es instantáneo y no hay que re-renderizar ninguna lista.
 * Es preferencia del NAVEGADOR, como el fondo: no viaja al servidor.
 */

export const DENSITY_STORAGE_KEY = 'cmdb-density';

export const DENSITIES = [
  {
    id: 'auto',
    name: 'Automática',
    tagline: 'Compacta solo en pantallas bajas o estrechas',
  },
  {
    id: 'comfortable',
    name: 'Cómoda',
    tagline: 'Filas altas, más aire entre datos',
  },
  {
    id: 'compact',
    name: 'Compacta',
    tagline: 'Filas bajas, más datos por pantalla',
  },
];

export const DEFAULT_DENSITY = 'auto';

export function isValidDensity(id) {
  return DENSITIES.some((d) => d.id === id);
}

export function readStoredDensity() {
  try {
    const stored = localStorage.getItem(DENSITY_STORAGE_KEY);
    if (stored && isValidDensity(stored)) return stored;
  } catch {
    // Almacenamiento bloqueado: se usa la de fábrica.
  }
  return DEFAULT_DENSITY;
}

/** Escribe la densidad en <html>. Devuelve la aplicada. */
export function applyDensity(id) {
  const value = isValidDensity(id) ? id : DEFAULT_DENSITY;
  document.documentElement.setAttribute('data-density', value);
  return value;
}

/** Guarda y aplica. Devuelve lo aplicado para poder pintar el selector. */
export function saveDensity(id) {
  try {
    if (id && id !== DEFAULT_DENSITY) localStorage.setItem(DENSITY_STORAGE_KEY, id);
    else localStorage.removeItem(DENSITY_STORAGE_KEY);
  } catch {
    // Sin persistencia: se aplica igualmente en esta sesión.
  }
  return applyDensity(id);
}

/** Se llama antes de renderizar (index.js), como el tema y el fondo. */
export function bootDensity() {
  return applyDensity(readStoredDensity());
}
